import ContactList from "./components/ContactList"

export default function ContactsPage() {
  return <ContactList />
}
